<template>
	<div class="leave-message-textarea">
		<el-input
		  type="textarea"
		  placeholder="请输入内容"
		  v-model="textarea"
		  maxlength="300"
		  show-word-limit
		  resize="none"
		  @input="inputEvent"
		>
		</el-input>
	</div>
</template>

<script>
	export default {
		props:['source'],
		watch:{
			source(value){
				this.textarea = value;
			}
		},
		data(){
			return {
				textarea:''
			}
		},
		methods:{
			inputEvent(){
				this.$emit('finish',{
					type:'text',
					source:this.textarea
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.leave-message-textarea {
		height: 100%;
		::v-deep {
			.el-textarea,
			.el-textarea__inner {
				width: 100%;
				height: 100%;
				border: none;
			}
		}
	}
</style>